import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterSettingsService } from 'src/app/services/master-settings.service';

@Component({
    selector: 'app-update-master-settings',
    templateUrl: './update-master-settings.component.html',
    styleUrls: ['./update-master-settings.component.scss'],
    standalone: false // NOSONAR
})
export class UpdateMasterSettingsComponent implements OnInit {
  heading: any;
  domicile: string;
  updateTrigger: number;
  redTrigger: number;
  yellowTrigger: number;
  snoozeDelay: number;
  errormsg: any;

  constructor(
    public dialogRef: MatDialogRef<UpdateMasterSettingsComponent>,
     private readonly service : MasterSettingsService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any
  ) {}

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    
    this.domicile = this.dataStore.params.domicile;
    this.updateTrigger = this.dataStore.params.updateTrigger;
    this.redTrigger = this.dataStore.params.redTrigger;
    this.yellowTrigger = this.dataStore.params.yellowTrigger;
    this.snoozeDelay = this.dataStore.params.snoozeDelay;
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  validate(value: number) {
    if (value % 10 == 0) {    // NOSONAR
      return true;
    }
    return false;
  }

  nullOrValue(param: number) {
    if (param == null || param == 0) {    // NOSONAR
      return null;
    }
    return param;
  }

  saveClick() {
    const params = {
      domicile: this.domicile,
      updateTrigger: this.nullOrValue(this.updateTrigger),
      redTrigger: this.nullOrValue(this.redTrigger),
      yellowTrigger: this.nullOrValue(this.yellowTrigger),
      snoozeDelay: this.nullOrValue(this.snoozeDelay),
    };
    if(this.yellowTrigger >= this.redTrigger){
      this.errormsg = 'Value for Yellow Trigger should always be less than Red Trigger.';
      return;
    }
    if (
      !this.validate(this.updateTrigger) ||
      !this.validate(this.redTrigger) ||
      !this.validate(this.yellowTrigger) ||
      !this.validate(this.snoozeDelay)
    ) {
      
      this.errormsg = 'Valid values are numbers in the increment of 10 from 0 please check.'
      return;
    }
    this.service.updateMasterSettings(params).subscribe({
      next: (_res: any) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'success' });
      },
      error: (error) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'failure' });
        console.info(error);
      },
    });
  }
}
